import { CustomElement, resolve } from 'aurelia';
import { ImageCacheAdminService } from '../../services';
import template from './image-cache-admin-panel.html';
import './image-cache-admin-panel.css';

// Admin-only modal to manage the image → (brand, toy line) cache: list, add, update, and delete
// records. Opened from the admin menu; all state and load/save/delete calls live in
// ImageCacheAdminService. This is the manual fallback for tagging images when the Brand Vision
// service is disabled.
export class ImageCacheAdminPanelElement {
  readonly imageCacheAdmin: ImageCacheAdminService = resolve(ImageCacheAdminService);
}

export const ImageCacheAdminPanel = CustomElement.define({
  name: 'image-cache-admin-panel',
  template
}, ImageCacheAdminPanelElement);
